import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { IPageHeaderMeta } from '../../../shared/components/header/page-header/page-header-meta.interface';
import { IGroupData } from '../../../shared/models/list-models';
import { SortAndFilterService, TSortDirections } from '../../../shared/services/list-services/sort-and-filter.service';

@Component({
  selector: 'shelter-network-settings-content',
  template: require('./shelter-network-settings-content.component.html'),
  styles: [require('./shelter-network-settings-content.component.scss')],
})
export class ShelterNetworkSettingsContentComponent implements OnInit {
  @Input() groupData$: BehaviorSubject<IGroupData>;
  @Output() clickedMoreButton = new EventEmitter();

  public batchActionsMode$: Observable<boolean>;
  public columnIndexMap: { [key: string]: number };
  public columns: any[];
  public listConfig: any;
  public sortDirection$: BehaviorSubject<TSortDirections>;
  public sortKey$: BehaviorSubject<string>;

  public pageHeaderMeta: IPageHeaderMeta = {
    textboxPlaceholder: 'Find a user...',
  };
  public userFilter: FormControl = new FormControl();

  ngOnInit(): void {
    this.sortKey$ = new BehaviorSubject('NAME');
    this.sortDirection$ = new BehaviorSubject('asc');
    this.columns = [
      {
        columnName: 'Name',
        columnOrder: 0,
        graphQlKey: 'SHELTER_USER_NAME',
      },
      {
        columnName: 'job title',
        columnOrder: 1,
        graphQlKey: 'SHELTER_JOB_TITLE',
      },
      {
        columnName: 'has access',
        columnDataFormat: '',
        columnOrder: 2,
        graphQlKey: 'SHELTER_ACCESS_LEVEL',
      },
      {
        columnName: 'shelter portfolio',
        columnOrder: 3,
        graphQlKey: 'SHELTER_PORTFOLIO',
      },
      {
        columnName: null,
        columnOrder: 4,
        graphQlKey: 'SHELTER_MORE',
      },
    ];

    this.batchActionsMode$ = of(false);

    this.columnIndexMap = this.columns.reduce((mapping, col: any, i: number) => {
      mapping[col.graphQlKey] = i;
      return mapping;
    }, {});

    this.listConfig = {
      listType: 'USER',
      noDataMessage: 'No users to display',
      sortableColumns: true,
    };
  }

  public onMoreButtonClick({ action, user }): void {
    this.clickedMoreButton.emit({ action, user });
  }

  public updateSort(sortKey: string): void {
    SortAndFilterService.updateSortCol(sortKey, this.sortKey$, this.sortDirection$);
  }
}
